import { render, staticRenderFns } from "./Temblores.vue?vue&type=template&id=6e1b342c&scoped=true"
import script from "./Temblores.vue?vue&type=script&lang=js"
export * from "./Temblores.vue?vue&type=script&lang=js"
import style0 from "./Temblores.vue?vue&type=style&index=0&id=6e1b342c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b342c",
  null
  
)

export default component.exports